module.exports = function () {
  var source = {};

  return {
    setSource,
    abort,
    source
  };

  function setSource(source) {
    source = _.cloneDeep(source);
  }

  function abort() {
    source = null;
  }
};